<template>
  <v-dialog max-width="1200px" persistent v-model="dialog" scrollable>
    <v-card v-if="dialog == true">
      <v-toolbar dark dense>
        <v-toolbar-title class="headline">{{formTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="cancelAddProduct()">close</v-icon>
      </v-toolbar>

      <v-card-text style="height: auto;padding:0;" v-if="close_cropper">
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-tabs dark v-model="tabs" grow>
              <v-tabs-slider color="yellow"></v-tabs-slider>
              <v-tab v-for="item in lang" :key="item">{{ item }}</v-tab>
            </v-tabs>

            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-select
                  :disabled="fetching_data"
                  :loading="fetching_data == true ? 'black' : false"
                  v-model="form.product_type_id"
                  :items="product_type_item"
                  item-text="product_type_name_th"
                  item-value="product_type_id"
                  label="Product type"
                  :rules="form.product_type_id ? [v => !!v || 'type is required'] : []"
                ></v-select>
                <v-tabs-items v-model="tabs">
                  <v-tab-item v-for="n in lang" :key="n">
                    <div style="padding-top:1px;">
                      <v-text-field
                        v-if="n === 'en'"
                        :disabled="fetching_data"
                        :loading="fetching_data == true ? 'black' : false"
                        @input="upperEn($event)"
                        v-model="form.product_name_en"
                        :label="'Product name ('+ n.toUpperCase() + ')'"
                        :rules="form.product_name_en ? [rules.max] : []"
                      ></v-text-field>
                      <v-text-field
                        v-else-if="n === 'th'"
                        :disabled="fetching_data"
                        :loading="fetching_data == true ? 'black' : false"
                        @input="upperTh($event)"
                        v-model="form.product_name_th"
                        :label="'Product name ('+ n.toUpperCase() + ')'"
                        :rules="form.product_name_th? n == 'th' ? [v => !!v || 'name is required',rules.max] : [v => true || ''] : []"
                      ></v-text-field>
                      <!-- v-model="form['product_name_'+ n]" -->
                      <v-text-field
                        v-else
                        :disabled="fetching_data"
                        :loading="fetching_data == true ? 'black' : false"
                        @input="upperCn($event)"
                        v-model="form.product_name_cn"
                        :label="'Product name ('+ n.toUpperCase() + ')'"
                        :rules="form.product_name_cn?[rules.max]:[]"
                      ></v-text-field>
                      <v-textarea
                        :disabled="fetching_data"
                        :loading="fetching_data == true ? 'black' : false"
                        v-model="form['product_description_'+ n]"
                        name="description"
                        label="Description"
                        value
                        rows="1"
                        :rules="form['product_description_'+ n] ? [rules.max_description] : []"
                      ></v-textarea>
                    </div>
                  </v-tab-item>
                </v-tabs-items>

                <v-layout row justify-center style="margin-bottom:15px;">
                  <v-flex xs2 style="display:flex;align-items:center;">
                    <v-chip
                      color="grey"
                      text-color="white"
                      style="font-weight: 900;font-size: 16px;"
                    >
                      <v-icon left>star</v-icon>Other
                    </v-chip>
                  </v-flex>
                  <v-flex xs10 style="display:flex;align-items:center;">
                    <v-layout row justify-space-around>
                      <v-flex xs3>
                        <v-checkbox
                          :disabled="fetching_data"
                          :loading="fetching_data == true ? 'black' : false"
                          v-model="form.product_recommend"
                          label="Recommend"
                          color="primary"
                          hide-details
                          style="margin:0;"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs7>
                        <v-checkbox
                          :disabled="fetching_data"
                          :loading="fetching_data == true ? 'black' : false"
                          v-model="form.product_best_seller"
                          label="Best Seller"
                          color="primary"
                          hide-details
                          style="margin:0;"
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                    <br>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs6 class="mr-2">
                    <v-text-field
                      :disabled="fetching_data"
                      :loading="fetching_data == true ? 'black' : false"
                      v-model="form.product_pos_sale_price"
                      label="POS sale price"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="ml-2">
                    <v-text-field
                      :disabled="fetching_data"
                      :loading="fetching_data == true ? 'black' : false"
                      v-model="form.product_pos_base_price"
                      label="POS base price"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs6 class="mr-2">
                    <v-text-field
                      :disabled="fetching_data"
                      :loading="fetching_data == true ? 'black' : false"
                      v-model="form.product_sale_price"
                      label="Online sale price"
                      :rules="[v => !!v || 'price is required']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="ml-2">
                    <v-text-field
                      :disabled="fetching_data"
                      :loading="fetching_data == true ? 'black' : false"
                      v-model="form.product_base_price"
                      label="Online base price"
                      :rules="[v => !!v || 'price is required']"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-select
                  :disabled="fetching_data"
                  :loading="fetching_data == true ? 'black' : false"
                  v-model="form.product_status"
                  :items="product_status"
                  item-value="value"
                  item-text="name"
                  label="Product status"
                ></v-select>
                <v-select
                  :disabled="fetching_data"
                  :loading="fetching_data == true ? 'black' : false"
                  v-model="form.product_approve"
                  :items="approve_status"
                  item-value="value"
                  item-text="name"
                  label="Approve status"
                ></v-select>

                <v-layout row>
                  <v-flex xs3 style="position:relative;">
                    <label
                      style="font-size:17px;position:absolute;top:15px;color:#616A6B;"
                    >Upload Image :</label>
                  </v-flex>
                  <v-flex xs9 class="ml-2">
                    <v-btn
                      :disabled="fetching_data"
                      :loading="fetching_data "
                      @click="$refs.imageInput.click()"
                    >Choose Files</v-btn>
                    <span
                      class="ml-2"
                    >{{this.form.product_image && this.form.product_image != null ? showImageName : null}}</span>
                    <input
                      style="display:none;"
                      type="file"
                      @change="onImageSelected"
                      ref="imageInput"
                      accept="image/*"
                    >
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
            <v-card-actions v-if="editedIndex !== -1">
              <v-spacer></v-spacer>
              <v-btn
                :disabled="fetching_data"
                :loading="fetching_data"
                color="red"
                depressed
                @click="reset()"
                dark
              >reset</v-btn>
              <v-btn
                :disabled="fetching_data"
                :loading="fetching_data"
                color="green"
                depressed
                @click="saveEditInfo()"
                dark
              >Save</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-flex>
          <v-flex xs12 md6>
            <v-divider class="mb-3 hidden-md-and-up"/>
            <v-toolbar dense flat color="transparent">
              <v-toolbar-title>Option List</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn round small color="primary" class="black--text" @click="toAddOption()">
                <v-icon>add</v-icon>add option
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <newOptionForm
                :editedIndex="editedIndex"
                :form_option="form_option"
                @cancel="cancelAddOption()"
                @save="saveAddOption($event)"
                v-if="show_add_option_form == true"
              />
              <optionDetail
                :editedIndex="editedIndex"
                v-for="(info,index) in form.product_option"
                :key="index"
                :info="info"
                @removeOption="removeOption($event,index)"
              />
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text v-else>
        <imageCropper
          :aspectRatio="1/1"
          :imageName="image_name"
          :imgSrc="imgSrc"
          :height="300"
          @close="close_cropper = true"
          @setImageName="image_name = $event"
          @getCroped="getCropped($event)"
          v-if="imgSrc != ''"
        />
      </v-card-text>
      <v-divider v-if="close_cropper"></v-divider>
      <v-card-actions v-if="editedIndex === -1 && close_cropper">
        <v-spacer></v-spacer>
        <v-btn color="red" flat @click="cancelAddProduct()">Cancel</v-btn>
        <v-btn color="green" @click="saveProduct()" flat>Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import imageCropper from "@/components/Plugins/imageCropper.vue";
import newOptionForm from "./NewOptionForm";
import optionDetail from "./OptionDetail";
import { mapState } from "vuex";
export default {
  components: {
    imageCropper,
    newOptionForm,
    optionDetail
  },
  props: ["dialog", "editedIndex", "form", "original_data", "fetching_data"],
  data() {
    return {
      close_cropper: true,
      img_name: "",
      imgSrc: "",
      change_image: 0,
      form_option: {},
      image_name: "",
      show_add_option_form: false,
      valid: true,
      rules: {
        max: value => value.length <= 55 || "Maximum length is 55 characters.",
        max_description: value =>
          value.length <= 255 || "Maximum length is 255 characters."
      },
      product_status: [
        {
          name: "Active",
          value: true
        },
        {
          name: "Inactive",
          value: false
        }
      ],
      approve_status: [
        {
          name: "Online",
          value: 2
        },
        {
          name: "Offline",
          value: 0
        }
      ],
      product_name: "",
      base_price: "",
      sale_price: "",
      tabs: 0,
      lang: ["th", "en", "cn"]
    };
  },

  computed: {
    ...mapState({
      product_type_item: state => state.fetchProductTypeBack.product_type_list
    }),
    showImageName() {
      if (this.editedIndex != -1 && this.image_name == "") {
        let name = this.form.product_image.split("/");
        this.image_name = name[name.length - 1];
        this.form.product_image = null;
      }
      return this.image_name;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Product" : "Edit Product";
    }
  },
  watch: {
    dialog() {
      if (this.dialog == true) {
        this.change_image = 0;
        this.$refs.form.resetValidation();
      }
    }
  },
  methods: {
    upperEn(val) {
      this.form.product_name_en = val.toUpperCase();
    },
    upperTh(val) {
      this.form.product_name_th = val.toUpperCase();
    },
    upperCn(val) {
      this.form.product_name_cn = val.toUpperCase();
    },
    async removeOption(option_info, index) {
      if (option_info.option_id) {
        let checkSuccess = await this.$store.dispatch(
          "fetchProductListBack/delOption",
          option_info.option_id
        );
        if (checkSuccess == true) {
          this.form.product_option.splice(index, 1);
        }
      } else {
        this.form.product_option.splice(index, 1);
      }
    },
    reset() {
      let resetForm = JSON.parse(JSON.stringify(this.original_data));
      delete resetForm.product_option;
      Object.assign(this.form, resetForm);
      this.image_name = "";
    },
    async saveEditInfo() {
      if (this.$refs.form.validate()) {
        let sendForm = Object.assign({}, this.form);
        delete sendForm.product_option;
        if (this.change_image == 0) {
          delete sendForm.product_image;
        }
        this.$emit("setFetchingData", true);
        let checkSuccess = await this.$store.dispatch(
          "fetchProductListBack/editProduct",
          sendForm
        );
        this.$emit("setFetchingData", false);
        if (checkSuccess == true) {
          this.form.product_image = null;
          this.image_name = "";
          this.$emit("setDialog", false);
          this.$emit("setEditIndex", -1);
          this.cancelAddOption();
          this.$emit("fetchData", true);
          await this.$store.dispatch("fetchProductListBack/getData");
          this.$emit("fetchData", false);
        } else {
          this.reset();
        }
      }
    },
    setFormOption() {
      this.form_option = {
        option_choice: [
          {
            choice_name_th: null,
            choice_name_en: null,
            choice_name_cn: null,
            choice_price: null
          }
        ]
      };
    },
    getCropped(image_value) {
      this.form.product_image = image_value;
      this.change_image = 1;
      this.imgSrc = "";
    },
    onImageSelected(event) {
      let file = event.target.files[0];
      this.image_name = file.name;
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.imgSrc = reader.result;
        this.close_cropper = false;
      });
      reader.readAsDataURL(file);
    },
    cancelAddOption() {
      this.show_add_option_form = false;
      this.setFormOption();
    },
    saveAddOption(data) {
      this.show_add_option_form = false;
      if (this.editedIndex == -1) {
        this.form.product_option.push(this.form_option);
      } else {
        this.form.product_option.push(data);
      }
      this.setFormOption();
    },
    toAddOption() {
      this.show_add_option_form = true;
      if (this.editedIndex != -1) {
        this.form_option.option_product_id = this.form.product_id;
      }
    },
    saveProduct() {
      if (this.$refs.form.validate()) {
        this.image_name = "";
        if (this.change_image == 0) {
          delete this.form.product_image;
        }
        this.$store.dispatch("fetchProductListBack/addProductList", this.form);
        this.$emit("addProduct");
        this.$emit("setDialog", false);
        this.$emit("setEditIndex", -1);
      } else {
        if (
          this.form.product_name_th == "" ||
          this.form.product_name_th == null
        ) {
          this.tabs = 0;
        } else if (
          this.form.product_name_en == "" ||
          this.form.product_name_en == null
        ) {
          this.tabs = 1;
        }
      }
    },
    cancelAddProduct() {
      this.image_name = "";
      this.$emit("setDialog", false);
      this.$emit("setEditIndex", -1);
      this.cancelAddOption();
    }
  },
  created() {
    this.setFormOption();
  }
};
</script>



